import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-status-label',
  templateUrl: './status-label.component.html',
  styleUrls: ['./status-label.component.css']
})
export class StatusLabelComponent implements OnInit {
  @Input() title: string;
  @Input() bgColor: string;
  constructor() { }

  ngOnInit() {
  }

}
